import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ComparePageHero } from "../components/ComparePageHero";
import { ComparePageLegacyBody } from "../components/ComparePageLegacyBody";
import { ComparePageRating } from "../components/ComparePageRating";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.ComparePageVariantCTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ComparePageHero page={props.page} />
            <ComparePageRating
                rating={props.rating}
                numReviews={props.num_reviews}
            />
            <ComparePageLegacyBody page={props.page} layout="legacy_c" />
        </PageSkeleton>
    );
};
